import { render, staticRenderFns } from "./editGruppiMailDettagliSelGroups.vue?vue&type=template&id=ffe728d4&scoped=true&"
import script from "./editGruppiMailDettagliSelGroups.vue?vue&type=script&lang=js&"
export * from "./editGruppiMailDettagliSelGroups.vue?vue&type=script&lang=js&"
import style0 from "./editGruppiMailDettagliSelGroups.vue?vue&type=style&index=0&id=ffe728d4&scoped=true&lang=css&"
import style1 from "./editGruppiMailDettagliSelGroups.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe728d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VImg,VRow,VTextField})
